(function () {
    'use strict';

    function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    function getFormatedDate(date) {
        var arr = date.split("-");
        var month = arr[0];
        var day = arr[1];
        var year = arr[2];
        if (month.length === 1)
            month = "0" + month;
        if (day.length === 1)
            day = "0" + day;
        return year + "-" + month + "-" + day;
    }

    function calendarRedirect(arg) {
        var clickedDate = $('span[data-date="' + arg + '"]', $('.dzscalendar'));
        var url = $('.dzscalendar').data('url');
        if (!$(clickedDate).hasClass('hasEvent')) {
            return;
        }

        var tag = getUrlVars()["caltag"];
        var date = "";
        if (arg && arg.length > 0) {
            date = getFormatedDate(arg);
        }
        if (tag && tag.length > 0) {
            window.location.href = url + '?caldate=' + date + '&caltag=' + getUrlVars()["caltag"];
            return;
        }

        window.location.href = url + '?caldate=' + date;
    }

    $(document).ready(function () {

        var initMenuOverrides = function () {

            var $navbarToggler = $('button.navbar-toggler');
            var navbarSelector = $navbarToggler.attr('data-target');
            var $navbar = $(navbarSelector);

            // When toggling menu (normally mobile menu), lookup active items
            // and add trigger 'show' in order to expand dropdown menus (if any)
            $navbarToggler.on('click.furillo', function (e) {

                // When desktop or when closing there's no need to run this
                if (!$navbarToggler.is(':visible') || $(this).attr('aria-expanded') === 'true') {
                    return;
                }

                $('.nav-item.dropdown.active', $navbar).each(function () {
                    $('.collapse', $(this)).first().collapse('show');
                });
            });

            // Since we use BS 'collapse' rather than 'dropdown' for menu we need
            // to add this to close all open collapses when clicking outside of the menu.
            $(document).on('click.furillo', function (e) {

                // If on mobile or still within the navbar, no need to run this
                if ($navbarToggler.is(':visible') || $(e.target).parents('.navbar').length > 0)
                    return;

                $('.nav-item .collapse.show').collapse('hide');
            });

            // Move the search form to and from the mobile menu
            $(document).on('show.bs.collapse', navbarSelector, function (e) {

                if ('#' + $(e.target).attr('id') !== navbarSelector) {
                    return;
                }

                var $form = $('#quicksearch form').detach();
                $('#toggled-quicksearch', $navbar).append($form);
            });

            $(document).on('hidden.bs.collapse', navbarSelector, function (e) {

                if ('#' + $(e.target).attr('id') !== navbarSelector) {
                    return;
                }

                var $form = $('#toggled-quicksearch form', $navbar).detach();
                $('#quicksearch').append($form);
            });

            var timeoutId = null;
            $navbar.on('mouseover.furillo', '.nav-item.dropdown', function (e) {

                // If on mobile there's no need to run this
                if ($navbarToggler.is(':visible'))
                    return;

                var $this = $(this);

                // If already open (like the parent), no need to run
                if ($('.collapse.show', $this).first().length > 0) {
                    return;
                }

                if (timeoutId !== null) {
                    clearTimeout(timeoutId);
                }

                timeoutId = setTimeout(function () {
                    $('.collapse', $this).first().collapse('show');

                    // Always only one open
                    $this.siblings('.nav-item.dropdown').each(function () {
                        $('.collapse.show', this).first().collapse('hide');
                    });

                    timeoutId = null;
                }, 250);
            });

            $navbar.on('mouseleave.furillo', '.nav-item.dropdown', function (e) {

                // If on mobile there's no need to run this
                if ($navbarToggler.is(':visible'))
                    return;

                $('.collapse.show', this).first().collapse('hide');
            });
        };

        initMenuOverrides();

        $(document).on('click', '[data-toggle="lightbox"]', function (e) {
            e.preventDefault();
            $(this).ekkoLightbox({
                showArrows: true
            });
        });

        $(document).on('click', '.cookies-close', function () {
            $(this).parents('.cookie-disclaimer').addClass('hidden');

            setTimeout(function () {
                var days = 30;
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

                var expires = date.toGMTString();
                document.cookie = 'accepted_cookies=true; expires=' + expires + '; path=/';
            }, 260);
        });

        $('.dzscalendar').each(function () {

            $(this).dzscalendar({
                design_transitionDesc: 'tooltipDef',
                start_weekday: 'Monday',
                mode: 'datepicker'
            });
            document.getElementById($(this).attr('id')).arr_datepicker_events.push(calendarRedirect);
        });

        $('.tag-filters').tagfilter();
        $('body').noreferrer();
    });
}());